import { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import Image from "next/image";
import styles from "../styles/Home.module.css";
import { Link, Flex, Text } from "rebass";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../styles/LLTheme";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faTwitter, faDiscord, faMedium, faInstagram, IconLookup } from '@fortawesome/free-brands-svg-icons'
import { faBook } from "@fortawesome/free-solid-svg-icons"
import { Tiles } from "@rebass/layout";

const Header = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const precentage = Math.min(scrollPosition / 100, 1);
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          position: "fixed",
          top: 0,
          width: "100%",
          // px: '50px',
          transition: "0.8s cubic-bezier(0.2, 0.8, 0.2, 1)",
          backgroundColor: `rgba(40, 40, 40, ${0.8 * precentage})`,
          justifyContent: "center",
          backdropFilter: `blur(${precentage * 20}px)`,
          alignItems: "center",
          borderBottom: `0.5px solid rgba(80, 80, 80, ${0.8 * precentage})`,
          zIndex: 9999,
        }}
      >
        <Flex width="100%" sx={{ display: "flex", alignItems: "center", gap: '12px' }} flexDirection={"column"}>

        <Flex
          width="100%"
          backgroundColor="#222222"
          sx={{ gap: "5%", width: "100vw"  }}
        >
            <Text
              fontSize={["12px", "15px", "18px"]}
              py={"10px"}
              sx={{
                fontFamily: "Inter",
                fontWeight: "500",
                display: "flex",
                // letterSpacing: "0.04em",
                flex: 1,
                alignItems: "center",
                color: "rgba(255, 255, 255, 0.8)",
                justifyContent: "center"
              }}
            >
              <span style={{ whiteSpace: "pre", color: "#11EF8B" }}>
                {" "}
                Big News!
                {" "}
              </span>
              Lilico officially rebranded to {" "}
              <span style={{ whiteSpace: "pre", color: "#11EF8B" }}>
                {" "}
              </span>
              <Image
                alt="logo"
                src="/frw-logo.png"
                width={25}
                height={25}
                style={{
                  width: "25px",
                  height: "25px",
                  display: "inline-block",
                  marginRight: "5px",
                  marginLeft: "5px",
                  maxWidth: "100%"
                }} />
              <span style={{ whiteSpace: "pre", color: "#11EF8B" }}>
                {" "}
              </span>
              {" "} Flow Reference Wallet ! {" "}

              <span style={{ whiteSpace: "pre", color: "#11EF8B" }}>
                <Link href='https://core.flow.com'>{" "} Learn More {">"}</Link>
              </span>
            </Text>
          </Flex>

        <Flex width={[0.98,0.9,0.8]}sx={{ display: "flex", alignItems: "center", gap: '12px', py: `${18 - precentage * 5}px` }}>
          <Link href="/">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#f9f9f9",
              px: "12px",
              py: "8px",
              borderRadius: "50px",
            }}
          >
            <Box
              className={styles.logoContainer}
              style={{ height: "48px", width: "48px", aspectRatio: "1/1" }}
            >
              <Image
                src="/logo-cat.svg"
                alt="Lilico Logo"
                width={33}
                height={33}
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </Box>
            <Image
              src="/logo-text.svg"
              alt="Lilico Text Logo"
              width={100}
              height={40}
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />
          </Box>
          </Link>
          <Box sx={{ flexGrow: 1 }} />

          <IconButton onClick={() => { window.open('https://outblock.notion.site/Lilico-Documentation-Index-b97f6c9203384a80994161e8d00ce1b5')?.focus() }}>
            <FontAwesomeIcon icon={faBook} style={{ color: '#f9f9f9', fontSize: '22px', aspectRatio: '1/1'}} />
          </IconButton>

          <IconButton onClick={() => { window.open('https://twitter.com/lilico_app')?.focus() }}>
            <FontAwesomeIcon icon={faTwitter} style={{ color: '#f9f9f9', fontSize: '22px', aspectRatio: '1/1'}} />
          </IconButton>

          <IconButton onClick={() => { window.open('https://discord.gg/DtZkFTay2U')?.focus() }}>
            <FontAwesomeIcon icon={faDiscord} style={{ color: '#f9f9f9', fontSize: '25px', aspectRatio: '1/1'}} />
          </IconButton>

          <Button
            onClick={() => { window.open('https://lilico.app/download')?.focus()}}
            variant="outlined"
            sx={{
              borderRadius: "32px",
              textTransform: "capitalize",
              px: "32px",
              color: "#f9f9f9",
              height: "45px",
              border: "1px solid #f9f9f9",
              // backgroundColor: "#f9f9f9",
              fontWeight: "800",
              fontFamily: "Inter, sans-serif",
              "&:hover": { 
                backgroundColor: "#f9f9f9", 
                color: "#282828",
                border: "1px solid #f9f9f9",
              },
            }}
          >
            {/* <Typography
              sx={{ textTransform: "capitalize", fontWeight: "800" }}
              variant="subtitle1"
              // color="neutral.main"
            > */}
              Download
            {/* </Typography> */}
          </Button>
        </Flex>
        </Flex>
      </Box>
    </ThemeProvider>
  );
};

export default Header;
